// extracted by mini-css-extract-plugin
export var colorSquare = "_sv-0";
export var danger = "_sv-5";
export var lightPink = "_sv-8";
export var neutralBlue = "_sv-7";
export var neutralYellow = "_sv-6";
export var normal = "_sv-1";
export var primary = "_sv-2";
export var primaryLight = "_sv-3";
export var solidBlack = "_sv-g";
export var solidGreen = "_sv-b";
export var solidLightBlue = "_sv-d";
export var solidNavy = "_sv-c";
export var solidOrange = "_sv-f";
export var solidPink = "_sv-e";
export var solidRed = "_sv-9";
export var solidYellow = "_sv-a";
export var success = "_sv-4";